<template>
  <div class="relative">
    <!-- IMAGE -->
    <AppImage
      v-if="image"
      :class="{ 'w-1/2': halfWidth }"
      v-bind="$attrs"
      :loading="loading"
      :src="image.permalink"
      :alt="$i18n.locale === 'fr' ? image.alt_fr : image.alt"
      :style="`object-position: ${image.focus_css};`"
    />

    <!-- DOWNLOAD BUTTON -->
    <div
      v-if="downloadable"
      class="group absolute bottom-3 right-3 z-10 flex size-8 items-center justify-center rounded-sm transition-colors hover:bg-white 2xl:size-10"
    >
      <DownloadButton
        class="size-4 text-white before:absolute before:inset-0 group-hover:text-blue-800 sm:bottom-4 sm:right-4 2xl:size-5"
        :aria-label="`${$t('accessibility.download_image')}: ${
          caption || image?.alt
        }`"
        @click="downloadFile(image)"
      />
    </div>

    <!-- GRADIENT BEHIND BUTTON -->
    <div
      v-if="downloadable"
      class="absolute bottom-0 right-0 size-20 bg-gradient-to-tl from-[#012D43]/30 to-transparent to-50% sm:size-32"
    />
  </div>
</template>

<script setup>
defineProps({
  image: { type: Object, required: true },
  caption: { type: String, default: '' },
  downloadable: { type: Boolean, default: false },
  loading: { type: String, default: 'lazy' },
  halfWidth: { type: Boolean, default: false },
})

const isLoading = ref(false)

async function downloadFile(file) {
  // Files won't download directly when they are from another domain (security).
  // This function fetches it first and creates temporary local file which can then be downloaded direct.

  if (!file.is_image && !file.permalink) {
    console.error('File is not an image or has no permalink.')
    return
  }

  isLoading.value = true

  const response = await fetch(file.permalink)
  // Content to blob address
  const blob = await response.blob()
  // Create hidden downloadable links
  const objectUrl = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = objectUrl
  a.download = getTextAfterDoubleColon(file.id) || file.id
  document.body.appendChild(a)

  a.click()

  isLoading.value = false
  // remove
  setTimeout(() => document.body.removeChild(a), 1000)
}

function getTextAfterDoubleColon(str) {
  const regex = /::(.+)/
  const match = str.match(regex)

  if (match && match.length > 1) {
    return match[1]
  }

  return null
}
</script>
